import { render, staticRenderFns } from "./BotConfiguration.vue?vue&type=template&id=b9d16da6&scoped=true&"
import script from "./BotConfiguration.vue?vue&type=script&lang=js&"
export * from "./BotConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./BotConfiguration.vue?vue&type=style&index=0&id=b9d16da6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9d16da6",
  null
  
)

export default component.exports